// extracted by mini-css-extract-plugin
export default {"context-action-defined":"entity-visual-element_context-action-defined__rOiye"};